import styled from "styled-components";
import { Typography } from "@material-ui/core";

export default styled(Typography)`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: ${({ theme }) => `${theme.spacing(1)}px`};
  grid-area: copyright;
`;
